import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "m21.39 19.58-1.905 1.906s-4.95 2.121-12.02-4.95c-7.072-7.071-4.95-12.02-4.95-12.02L4.419 2.61a2 2 0 0 1 3.015.215l1.818 2.424a2 2 0 0 1-.186 2.614L7.464 9.465s0 1.414 2.829 4.243c2.828 2.828 4.242 2.828 4.242 2.828l1.602-1.602a2 2 0 0 1 2.614-.186l2.425 1.819a2 2 0 0 1 .214 3.014"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }